const labelsDefault = {
    name: {label: "name", required: true},
    panel: {label: "municipalities", required: true},
    devices: {label: "devices_count", required: true},
};

export default labelsDefault;
